import { MouseEventHandler } from 'react';

const IconButton = ({ icon, onClick }: { icon: string; onClick?: MouseEventHandler<HTMLButtonElement> }) => {
  return (
    <button type="button" onClick={onClick} className="border-0 bg-blue-400 rounded-circle aspect-1x1 wr-2-5 d-flex align-items-center justify-content-center">
      <i className={`text-blue-700 fa-solid fa-${icon}`} />
    </button>
  );
};

export default IconButton;
